import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';

PageRoute.propTypes = {
  insecure: PropTypes.bool,
  page: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  render: PropTypes.func,
};

export default function PageRoute({insecure, page: Page, render, children, ...otherProps}) {
  const SecurePage = (routeProps) => {
    return Page ? <Page {...routeProps}>{children}</Page> : render(routeProps);
  };
  return (<Route render={SecurePage} {...otherProps}/>);
}
